import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { refreshPermissions } from '../../store/slices/authSlice';

// Refresh the permission list whenever a session exists (fresh login or
// rehydrated from redux-persist) so guards never run on a stale permission set.
export const AuthBootstrap = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, token } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated && token) {
      dispatch(refreshPermissions());
    }
  }, [isAuthenticated, token, dispatch]);

  return null;
};

export default AuthBootstrap;
